import { defineMessages } from "react-intl";

const messages = defineMessages({
  cardTitle: {
    id: "dashboard.cards.upcomingActivities.title",
    defaultMessage:
      "Upcoming Activities <date>{dateRange, select, day {{dateSubRange, select, this {today} last {yesterday} other {}}} week {{dateSubRange, select, this {this week} last {last week} other {}}} month {{dateSubRange, select, this {this month} last {last month} other {}}} quarter {{dateSubRange, select, this {this quarter} last {last quarter} other {}}} year {{dateSubRange, select, this {this year} last {last year} other {}}} other{}}</date>",
    description: "Title of the Upcoming Activities card",
  },
  cardTitleWithEntity: {
    id: "dashboard.cards.upcomingActivities.title.withEntity",
    defaultMessage: "Upcoming Activities with {parentEntityName}",
    description: "Title of the Upcoming Activities card",
  },
  listSubtitle: {
    id: "dashboard.cards.upcomingActivities.listSubtitle",
    defaultMessage: "{count} {count, plural, one {record} other {records}}",
    description: "List subtitle of the Upcoming Activitiescard on the Dashboard page",
  },
  mapSubtitle: {
    id: "dashboard.cards.upcomingActivities.mapSubtitle",
    defaultMessage: "{count}/{totalCount} {totalCount, plural, one {record} other {records}}",
    description: "Map subtitle of the Upcoming Activitiescard on the Dashboard page",
  },
});

export default messages;
